import { h } from 'preact';
import { formatMoney } from 'utils/storefront/format-resource';

const ProgressBar = ({ progress }) => {
  const progressPercent = progress > 100 ? 100 : progress;

  return (
    <div className="h-4 w-full bg-grey-5">
      <div
        style={`width: ${progressPercent}%`}
        className="bg-faded-black h-full transition-all duration-500"
      ></div>
    </div>
  );
};

const FreeShipping = ({ threshold, cart }) => {
  if (threshold === null || !cart) return false;

  const totalCartPrice = Number(cart.state.total_price / 100);
  const percentage = (totalCartPrice / threshold) * 100;
  const priceAway = threshold - totalCartPrice;

  return (
    <div className="border-b border-grey-5 px-15 py-20 lg:px-20">
      <p className="body-12-light mb-12">
        {priceAway <= 0
          ? window.TMW.Strings.cart.thresholdReached
          : window.TMW.Strings.cart.shippingMessage.replace(
              '[[amount]]',
              formatMoney({
                amount: priceAway,
                currencyCode: window.TMW?.localization?.currencyCode,
              }),
            )}
      </p>
      <ProgressBar progress={percentage} />
    </div>
  );
};

export default FreeShipping;
